import React, { useEffect } from 'react';
import { Box, ChevronDownIcon, HStack, Pressable, useDisclose, VStack } from 'native-base';
import { UpArrowIcon } from '../Icons';
import Collapsed from './Collapsed';
import Expanded from './Expanded';
const Accordion = _ref => {
  let {
    children,
    isOpen: defaultOpen = false,
    onToggle,
    id = ''
  } = _ref;
  const {
    isOpen,
    onClose,
    onOpen
  } = useDisclose(defaultOpen);
  const [CollapsedContent, ExpandedContent] = React.Children.map(children, child => {
    return child.props.children;
  });
  useEffect(() => {
    if (defaultOpen) onOpen();else onClose();
  }, [defaultOpen, onOpen, onClose]);
  return /*#__PURE__*/React.createElement(VStack, {
    w: "full",
    key: `${id}`
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: onToggle
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, CollapsedContent), isOpen ? /*#__PURE__*/React.createElement(UpArrowIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null))), /*#__PURE__*/React.createElement(Box, {
    display: !isOpen ? 'none' : 'flex'
  }, ExpandedContent));
};
Accordion.Collapsed = Collapsed;
Accordion.Expanded = Expanded;
export default Accordion;
//# sourceMappingURL=Accordion.js.map